export default "__VITE_ASSET__54f30254__"